'use strict'
;(() => {
  // Check if value is a plain object (not Array, Date, etc.)
  let isPlainObject = (payload) => {
    let type = Object.prototype.toString.call(payload).slice(8, -1)
    if (type !== 'Object') return false
    let prototype = Object.getPrototypeOf(payload)
    return prototype.constructor === Object && prototype === Object.prototype
  }

  // Parse and validate section asset data
  let parseAssetData = (input) => {
    if (input == null) throw new Error('Input is not present')
    if (!isPlainObject(input)) throw new Error('Input is not a plain object')

    let sectionName = input.sectionName
    if (!sectionName || typeof sectionName !== 'string') {
      console.error('Section name is not defined', input)
      throw new Error('Section name is not defined')
    }

    let scripts = Array.isArray(input.scripts)
      ? input.scripts.filter(
          (value) => typeof value === 'string' && value.length > 0
        )
      : []

    if (scripts.length === 0) throw new Error('Script list is empty')
    return { scripts, sectionName }
  }

  // Extract section from Shopify event
  let parseSectionFromEvent = (evt) => {
    if (evt.target == null) return null

    let sectionId = evt.detail?.sectionId
    if (!sectionId || typeof sectionId !== 'string') return null

    return evt.target.getAttribute('id') === 'shopify-section-' + sectionId
      ? evt.target
      : null
  }

  // Run callback when DOM is ready
  let onDocumentReady = (fn) => {
    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      setTimeout(fn, 1)
      return
    }
    document.addEventListener('DOMContentLoaded', fn)
  }

  let Scripts = new Set()

  let initSectionAssets = (section) => {
    try {
      let scriptElement = section.querySelector(
        'script.json-portable-section-assets'
      )
      if (scriptElement == null) return

      let { sectionName, scripts } = parseAssetData(
        JSON.parse(scriptElement.innerText)
      )
      if (Scripts.has(sectionName)) return

      scripts.forEach((scriptSrc) => {
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = scriptSrc
        script.defer = true
        onDocumentReady(() => {
          document.body.appendChild(script)
        })
      })

      Scripts.add(sectionName)
    } catch (err) {
      console.error('Section assets cannot be initialized', err)
    }
  }

  onDocumentReady(() => {
    document.addEventListener('shopify:section:load', (evt) => {
      let section = parseSectionFromEvent(evt)
      if (section == null) return
      initSectionAssets(section)
    })

    let sections = document.querySelectorAll('.shopify-section')
    sections.forEach(initSectionAssets)
  })
})()
